<a href=".">
  <img
    width="{{ width }}"
    class="logo inner-logo"
    src="./assets/imgs/{{ imageName }}.svg"
    alt=""
  />
</a>
